export const locale = {
    lang: 'zh2',
    data: {
      'WIZARD': {
        'TESTTITULO':	'标题',
        'CARGANDO': '加载获取的产品',
        'CARGANDO_PULSOS': '正在加载脉冲',
        'SINPRODS': '您尚未购买此产品',
        'EVALUADOR':{
          'TITUTLO':'评估者'
        },
        'LANDING': {
          'PRODUCTO': {
            'CERTIFICAR':{
              'TITULO': '欢迎认证',
              'CURRENT': '这是您当前的认证过程',
              'FINISHED': '这是完成的认证过程',
              'RESULTS': {
                'CURRENT': '验证过程未完成',
                // 'FINISHED': '完成认证过程'
                'FINISHED': '这是您当前的认证过程',
                'FINISHED5': '处理结果'
              }
            },
            'Amco':{
              'TITULO': '欢迎来到 AMCO',
               'CURRENT': '这是当前的 amco 进程',
               'FINISHED': '这是一个完整的 amco 过程。',
              'RESULTS': {
                'CURRENT': 'Amco 流程未完成',
                'FINISHED': '这是当前的结果过程',
                'FINISHED5': '结果过程'
              }
            },
            'Trabajo_digno':{
              'TITULO': '欢迎从事体面的工作',
               'CURRENT': '这是目前的体面工作流程',
               'FINISHED': '这是一个完整的体面工作过程',
              'RESULTS': {
                'CURRENT': '体面的工作流程尚未完成。',
                'FINISHED': '这是当前的结果过程',
                'FINISHED5': '结果过程'
              }
            },
            'Primer_empleo':{
              'TITULO':'欢迎来到第一份工作',
               'CURRENT': '这是当前的第一个就业流程',
               'FINISHED': '这是完成的第一个工作流程。',
              'RESULTS': {
                'CURRENT': '第一个雇佣程序未完成',
                'FINISHED': '这是当前的结果过程',
                'FINISHED5': '结果过程',
              }
            },
            'CERTIFICAR_C3':{
              'TITULO': '欢迎认证',
              'CURRENT': '这是您当前的认证过程',
              'FINISHED': '这是完成的认证过程',
              'RESULTS': {
                'CURRENT': '验证过程未完成',
                // 'FINISHED': '完成认证过程'
                'FINISHED': '这是您当前的认证过程',
                'FINISHED5': '处理结果'
              }
            },
            'CERTIFICAR_C4':{
              'TITULO': '欢迎认证银',
              'CURRENT': '这是您当前的认证过程',
              'FINISHED': '这是完成的认证过程',
              'RESULTS': {
                'CURRENT': '验证过程未完成',
                // 'FINISHED': '完成认证过程'
                'FINISHED': '这是您当前的认证过程',
                'FINISHED5': '处理结果'
              }
            },

            'MEDIR':{
              'TITULO': '欢迎测量',
              'CURRENT': '这是您当前的测量过程',
              'FINISHED': '这是完成的测量过程',
              'RESULTS': {
                'CURRENT': '测量过程未完成',
                // 'FINISHED': '完成测量过程'
                'FINISHED': '这是您当前的测量过程',
                'FINISHED5': '处理结果'
              }
            },
            'MEDIR_M1':{
              'TITULO': '欢迎增强测量',
              'CURRENT': '这是您当前的测量过程',
              'FINISHED': '这是完成的测量过程',
              'RESULTS': {
                'CURRENT': '测量过程未完成',
                'FINISHED': '完成测量过程'
              }
            },
            'MEDIR_M2':{
              'TITULO': '欢迎使用测量+ MST',
              'CURRENT': '这是您当前的测量过程',
              'FINISHED': '这是完成的测量过程',
              'RESULTS': {
                'CURRENT': '测量过程未完成',
                'FINISHED': '完成测量过程'
              }
            },
            'MEDIR_M3':{
              'TITULO': '欢迎按地区测量',
              'CURRENT': '这是您当前的测量过程',
              'FINISHED': '这是完成的测量过程',
              'RESULTS': {
                'CURRENT': '测量过程未完成',
                'FINISHED': '完成测量过程'
              }
            },
            'MEDIR_M4':{
              'TITULO': '欢迎领导测量',
              'CURRENT': '这是您当前的测量过程',
              'FINISHED': '这是完成的测量过程',
              'RESULTS': {
                'CURRENT': '测量过程未完成',
                'FINISHED': '完成测量过程'
              }
            },
            'MEDIR_M5':{
              'TITULO': '欢迎按尺寸进行测量',
              'CURRENT': '这是您当前的测量过程',
              'FINISHED': '这是完成的测量过程',
              'RESULTS': {
                'CURRENT': '测量过程未完成',
                'FINISHED': '完成测量过程'
              }
            },
            'MEDIR_M6':{
              'TITULO': '欢迎进行认证',
              'CURRENT': '这是您当前的测量过程',
              'FINISHED': '这是完成的测量过程',
              'RESULTS': {
                'CURRENT': '测量过程未完成',
                'FINISHED': '完成测量过程'
              }
            },
            'PULSE':{
              'TITULO': '欢迎进行脉冲检查',
              'ADMINTITULO': '行政人员脉搏检查',
              'PRODU': '脉冲检查',
              'CURRENT': '这是您当前的脉搏检查过程',
              'PULSOS': '这是一个脉冲检查过程',
              'FINISHED': '这是完成的脉冲检查过程',
              'CARGANDO_PULSE':'正在处理加载脉冲检查',
              'ENTRAR': '开始',
              'RESULTS': {
                'CURRENT': '脉冲检查过程未完成',
                // 'FINISHED': '完成脉冲检查过程'
                'FINISHED': '这是您当前的脉搏检查过程'
              }
            },
            'FOCUS':{
              'SECTION': '网上论坛管理员',
              'TITLE': '网上论坛管理员',
              'SUBTI': '组的选择或创建',
              'LAND': {
                'NAME': '调查名称',
                'INICIO': '开始日期',
                'FIN': '目标日期',
                'AVANCE': '预先',
                'ESTADO': '状态',
                'COMP': '行为',
                'CREARENC': '创建调查',
                'DELETE': '删除',
                'EDIT': '编辑',
              },
              'TITULO': '欢迎来到重点领域',
              'CURRENT': '这是您当前的重点领域流程',
              'FINISHED': '这是完成的重点领域过程',
              'RESULTS': {
                'CURRENT': '重点领域流程未完成',
                'FINISHED': '完成重点领域流程'
              }
            },
            'FOCUS_1':{
              'SECTION': '网上论坛管理员',
              'TITLE': '网上论坛管理员',
              'SUBTI': '组的选择或创建',
              'ADMINTITULO': '行政管理人员重点领域',
              'PRODU': '焦点区域',
              'CARGANDO_FOCUS':'正在加载焦点区域',
              'TAB_PROC_FOC':'重点领域流程',
              'TAB_SUBIDA_COLB_FOC':'合作者上传',
              'INST_MOD_FILTER_1':'上载您的合作者清单',
              'INST_MOD_FILTER_2':'输入您选择的调查',
              'LAND': {
                'NAME': '调查名称',
                'INICIO': '开始日期',
                'FIN': '目标日期',
                'AVANCE': '预先',
                'ESTADO': '状态',
                'COMP': '行为',
                'CREARENC': '创建调查',
                'DELETE': '删除',
                'EDIT': '编辑',
              },
              'TITULO': '欢迎来到重点领域',
              'CURRENT': '这是您当前的重点领域流程',
              'FINISHED': '这是完成的重点领域过程',
              'RESULTS': {
                'CURRENT': '重点领域流程未完成',
                'FINISHED': '完成重点领域流程'
              }
            },
            'MEDIR_M9':{
              'TITULO': '欢迎参加 INNMOTION 调查',
              'CURRENT': '这是您当前的重点领域流程',
              'FINISHED': '这是完成的重点领域过程',
              'RESULTS': {
                'CURRENT': '重点领域流程未完成',
                'FINISHED': '完成重点领域流程'
              }
            },
          },
          'DONE': '申请年份',
          'LEGA': '旧版结果',
          'FOCUS': '调查到重点区域',
          'ENTRAR': '开始',
          'IR':'進入',
          ////instituto turquia///
          'INST-TURQUEY':{
            'TITULO':'文化简介文化审核5.0',
            'TITULO-1':'文化简介文化审核5.0',
            'TITULO1':'文化簡介文化審核5.0',
            'TITULO2':'文化簡介5.0',
            'TITULO3':'文化評估5.0',
            'TITULO4':'特别清单',

          },
          'INST-CHINA':{
            'TITULO':'文化审核',
            'TITULO1':'文化审核',
            'TITULO2':'文化评估 5.0',
            'TITULO3':'文化审核 SP',
            'TITULO4':'文化评估 5.0',
            'TITULO5':'4ALL 文化评估',
          },
          'INST-ESP':{
            'TITULO':'文化审核 ',
            'TITULO1':'文化审核 ',
            'TITULO2':'文化审核  5.0',
            'TITULO3':'行动计划',
          }
        },
        'STEPSTAT': {
          'LOCK': '锁步',
          'PEND': '步开',
          'COMP': '步骤完成'
        },
        'NOPRODUCTS': {
          'TITULO':	'贵公司没有已购入产品',
          'SUBTI':	'报价资料',
        },
        'GUIA35': {
          'TITULO': '指南NOM-035-STPS-2018',
          'SUBTITULO':'描述',
          'DESCRIPCION': '关于NOM-035-STPS-2018的信息',
          'ENTRAR': '开始'
          },
        'ENCUESTA35': {
          'TITULO': '投票机NOM-035-STPS-2018',
          'SUBTITULO':'描述',
          'DESCRIPCION': '下一节属于NOM-035-STPS-2018的调查员，其中将确定工人组织环境中的不同社会心理风险因素',
          'ENTRAR': '开始'
        },
        'Amco': {
          'TITULO': '安科',
        },
        'Trabajo_digno':{
             'TITULO': '体面的工作',
           },
           'Primer_empleo':{
             'TITULO': '第一份工作',
           },
           'NOM35V3': {
               'TITULO': '标准 035 3.0'
           },
           'CERTIFICAR_C4': {
               'TITULO': '银证'
           },
        'CERTIFICAR': {
          'TITULO': '证明',
          'STEPS': {
            'STP1': {
              'WIZBT': '语言能力',
              'TITULO': '语言能力',
              'SUBTI': '语言选择'
            },
            'STP_NPS': {
              'WIZBT': 'NPS',
              'TITULO': 'NPS',
              'SUBTI': 'NPS版'
            },
            'STP1-1': {
              'WIZBT': '试剂种类',
              'TITULO': '试剂种类',
              'SUBTI': '试剂选择'
            },
            'STP1-FOCUS-PLANTILLA': {
              'WIZBT': '范本',
              'TITULO': '范本',
              'SUBTI': '试剂选择'
            },
            ////idioma chino Simplificado 4ALL practice
            'STP2': {
              'WIZBT':	'4ALL 實踐',
              'TITULO':	'4ALL 實踐',
              'SUBTI':	'于贵公司的调研加入4ALL实践',
            },
            'STP_CONTROL': {
              'WIZBT': '控制问题',
              'TITULO': '控制问题',
              'SUBTI': '编辑控制问题'
            },
            'STP3': {
              'WIZBT':	'人口统计资料',
              'TITULO':	'人口统计资料',
              'SUBTI':	'插入要在调研中显示的人口统计信息. 注意:黄色的受众特征是可选的',
            },
            'STP3-1': {
              'WIZBT': '公开问题',
              'TITULO': '公开问题',
              'SUBTI': '输入未解决的问题'
            },
            'STP4': {
              'WIZBT':	'附加项',
              'TITULO':	'附加项',
              'SUBTI':	'在调查新增其他问题',
            },
            'STP4-FOCUS-PLANTILLA': {
              'WIZBT':	'个性化',
              'TITULO':	'个性化',
              'SUBTI':	'在调查新增其他问题',
            },
            'STP4-1': {
              'WIZBT':	'生成调查',
              'TITULO':	'生成调查',
              'SUBTI':	'生成调查',
              'WIZBT2':	'生成调查',
              'TITULO2':	'生成调查',
            },
            'STP5': {
              'WIZBT':	'员工',
              'TITULO':	'员工',
              'SUBTI':	'上载员工数据库',
            },
            'STP6': {
              'WIZBT':	'编排调研',
              'TITULO':	'编排调研',
              'SUBTI':	'安排调研的开始和发送提醒电邮的日期',
            },
            'STP7': {
              'WIZBT':	'邮件发送',
              'TITULO':	'邮件发送',
              'SUBTI':	'将调研邀请发送给您的员工',
            },
            // 'STP8': {
            //   'WIZBT':	'调查结束',
            //   'TITULO':	'调查结束',
            //   'SUBTI':	'调查结束前的进展',
            // },
            'STP8': {
              'WIZBT': '调查跟进',
              'TITULO': '调查跟进',
              'SUBTI': '调查结束前的进展'
            },
            'STP9': {
              'WIZBT': '激活调查',
              'TITULO': '激活调查',
              'SUBTI': '激活调查'
            },
            'STP10': {
              'WIZBT': '模板',
              'TITULO': '对模板进行修改',
              'SUBTI': '模板'
            },
            'STP_VOICE': {
              'WIZBT': '语音设置',
              'TITULO': '为带有音频的调查设置语音设置',
              'SUBTI': '为带有音频的调查设置语音设置'
            }
            }
          },
          'CERTIFICARAMCO': {
            'TITULO': 'AMCO',
          },
          'CERTIFICARTRABADIG': {
            'TITULO': '体面的工作',
          },
          'CERTIFICARADICPRIEMPL': {
            'TITULO': '第一份工作',
          },
          'CERTIFICAR35': {
            'TITULO': 'NOM-035-STPS-2018',
            'LANDING': {
              'TITULO': '欢迎来到NOM-035-STPS-2018',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            },
            'STEPS': {
              'STP1': {
                'WIZBT': '语言能力',
                'TITULO': '语言能力',
                'SUBTI': '语言选择'
              },
              'STP2': {
                'WIZBT': '4ALL实践',
                'TITULO': '4ALL实践',
                'SUBTI': '插入贵公司的4ALL做法进行调查'
              },
              'STP3': {
                'WIZBT': '客层',
                'TITULO': '客层',
                'SUBTI': '插入要在调查中显示的人口统计信息'
              },
              'STP4': {
                'WIZBT': '附加项',
                'TITULO': '附加项',
                'SUBTI': '为调查插入其他问题'
              },
              'STP5': {
                'WIZBT': '合作者',
                'TITULO': '合作者',
                'SUBTI': '上载公司合作者数据库'
              },
              'STP6': {
                'WIZBT': '时间表调查',
                'TITULO': '时间表调查',
                'SUBTI': '安排调查的发布和提醒日期'
              },
              'STP7': {
                'WIZBT': '邮件发送',
                'TITULO': '邮件发送',
                'SUBTI': '将调查邀请发送给您的合作者'
              },
              'STP8': {
                'WIZBT': '调查结束',
                'TITULO': '调查结束',
                'SUBTI': '调查结束前的进展'
              },'STP9':{
                'WIZBT': '沟通计划',
                'TITULO': '沟通计划',
                'SUBTI': '将调查邀请发送给您的合作者'
              },'STP10':{
                'WIZBT': '合作者',
                'TITULO': '合作者',
                'SUBTI': '为NOM035调查做好准备'
              }
            }
          },
          'PULSE': {
            'TITULO': '脉冲检查',
            'LANDING': {
              'TITULO': '欢迎进行脉冲检查',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            },
            'STEPS': {
              // 'STP1': {
              //   'WIZBT': '语言能力',
              //   'TITULO': '语言能力',
              //   'SUBTI': '语言选择'
              // },
              // 'STP1-1': {
              //   'WIZBT': '试剂种类',
              //   'TITULO': '试剂种类',
              //   'SUBTI': '试剂选择'
              // },
              // ////idioma chino Simplificado 4ALL practice
              // 'STP2': {
              //   'WIZBT':	'4ALL 實踐',
              //   'TITULO':	'4ALL 實踐',
              //   'SUBTI':	'于贵公司的调研加入4ALL实践',
              // },
              // 'STP3': {
              //   'WIZBT':	'人口统计资料',
              //   'TITULO':	'人口统计资料',
              //   'SUBTI':	'插入要在调研中显示的人口统计信息',
              // },
              // 'STP3-1': {
              //   'WIZBT': '公开问题',
              //   'TITULO': '公开问题',
              //   'SUBTI': '输入未解决的问题'
              // },
              // 'STP4': {
              //   'WIZBT':	'附加项',
              //   'TITULO':	'附加项',
              //   'SUBTI':	'在调查新增其他问题',
              // },
              // 'STP5': {
              //   'WIZBT':	'员工',
              //   'TITULO':	'员工',
              //   'SUBTI':	'上载员工数据库',
              // },
              'STP6': {
                'WIZBT':	'编排调研',
                'TITULO':	'编排调研',
                'SUBTI':	'安排调查日期脉搏检查',
              },
              'STP7': {
                'WIZBT':	'邮件发送',
                'TITULO':	'邮件发送',
                'SUBTI':	'将调研邀请发送给您的员工',
              },
              'STP8': {
                'WIZBT':	'调查进度',
                'TITULO':	'调查进度',
                'SUBTI':	'检查测量进度脉冲检查',
              }
              }
            },

          'MEDIR': {
            'TITULO': '测量',
            'LANDING': {
              'TITULO': '欢迎测量',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            }
          },
          'MEDIR_M1': {
            'TITULO': '增强测量',
            'LANDING': {
              'TITULO': '欢迎增强测量',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            }
          },
          'MEDIR_M2': {
            'TITULO': '测量+ MST',
            'LANDING': {
              'TITULO': '欢迎使用测量+ MST',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            }
          },
          'MEDIR_M3': {
            'TITULO': '按区域测量',
            'LANDING': {
              'TITULO': '欢迎按地区测量',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            }
          },
          'MEDIR_M4': {
            'TITULO': '领导测量',
            'LANDING': {
              'TITULO': '欢迎领导测量',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            }
          },
          'MEDIR_M5': {
            'TITULO': '按尺寸测量',
            'LANDING': {
              'TITULO': '欢迎按尺寸进行测量',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            }
          },
          'MEDIR_M6': {
            'TITULO': '认证措',
            'LANDING': {
              'TITULO': '欢迎进行认证',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            }
          },
          'MEDIR_M9': {
            'TITULO': '动感调查',
            'LANDING': {
              'TITULO': '欢迎参加 INNMOTION 调查',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            }
          },
          'FOCUS':{
            'TITULO': '重点地区',
            'LANDING': {
              'TITULO': '欢迎来到重点领域',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            },
            'STEPS': {
              'STP1': {
                'WIZBT': '语言能力',
                'TITULO': '语言能力',
                'SUBTI': '语言选择'
              },
              'STP2': {
                'WIZBT': '管理群组',
                'TITULO': '管理群组',
                'SUBTI': '插入贵公司的4ALL做法进行调查'
              },
              'STP3': {
                'WIZBT': '管理调查',
                'TITULO': '管理调查',
                'SUBTI': '插入要在调查中显示的人口统计信息'
              },
              'STP4': {
                'WIZBT': '调查委员会',
                'TITULO': '调查委员会',
                'SUBTI': '为调查插入其他问题'
              }
            }
          },
          'FOCUS_1':{
            'TITULO': '重点地区',
            'LANDING': {
              'TITULO': '欢迎来到重点领域',
              'DONE': '申请年份: ',
              'ENTRAR': '开始'
            },
            'STEPS': {
              'STP1': {
                'WIZBT': '语言能力',
                'TITULO': '语言能力',
                'SUBTI': '语言选择'
              },
              'STP2': {
                'WIZBT': '管理群组',
                'TITULO': '管理群组',
                'SUBTI': '插入贵公司的4ALL做法进行调查'
              },
              'STP3': {
                'WIZBT': '管理调查',
                'TITULO': '管理调查',
                'SUBTI': '插入要在调查中显示的人口统计信息'
              },
              'STP4': {
                'WIZBT': '调查委员会',
                'TITULO': '调查委员会',
                'SUBTI': '为调查插入其他问题'
              }
            }
          },
          'LEADER_GO':{
            'TITULO_ADMIN': 'LEADER GO® 欢迎管理员',
            'TITULO': 'LEADER GO® 欢迎光临',
            'TITULO_PRODUCT':'Leader Go® 管理员',
            'TITULO_PRODUCT2':'Leader Go®',
            'LANDING': {
              'TITULO': '欢迎来到LEADER GO。',
              'DONE': '申请年份:',
              'ENTRAR': '开始'
            },
            'STEPS': {
              'STP1': {
                'WIZBT': '语言',
                'TITULO': '语言',
                'SUBTI': '语言选择'
              },
              'STP2': {
                'WIZBT': '领袖选择',
               'TITULO': '领袖选择',
               'SUBTI': '选择领导者',
              },
              'STP3': {
                'WIZBT': '通讯讯息',
               'TITULO': '通讯讯息',
               'SUBTI': '登录编辑邮件',
              },
              'STP4': {
                'WIZBT': '确认',
               'TITULO': '确认',
               'SUBTI': '输入以确认发送电子邮件',
              },
              'STP5': {
                'WIZBT': '前进',
               'TITULO': '前进',
               'SUBTI': '前进',
              }
            }

          },
          'ACTION_GO':{
            'TITULO_ADMIN': 'ACTION GO® 欢迎管理员',
            'TITULO': 'ACTION GO® 欢迎',
            'TITULO_PRODUCT':'Action GO® 管理员',
            'TITULO_PRODUCT2':'Action GO®',
          },
          'LANDING_REQUERIMIENTOSV3':{
              'TITULO':'技术要求',
              'EXTERNAL_PORTAL': '复制外部RT网址',
              'COPYA_MESSAGE':'网址已复制到剪贴板',

          },
          'GOFLOW':{
            'TITULO': '结果 GoFlow',
          },
        }
      }
  };
